import { Link } from 'react-router-dom';

interface Props {
  variant?: 'default' | 'compact';
}

export function LegalFooter({ variant = 'default' }: Props) {
  if (variant === 'compact') {
    return (
      <p className="text-caption text-text-tertiary text-center">
        By continuing you agree to our{' '}
        <Link to="/terms" className="underline underline-offset-2 hover:text-accent">
          Terms
        </Link>{' '}
        and{' '}
        <Link to="/privacy" className="underline underline-offset-2 hover:text-accent">
          Privacy Policy
        </Link>
        .
      </p>
    );
  }

  return (
    <div className="flex items-center justify-center gap-4 text-caption text-text-tertiary">
      <Link to="/privacy" className="hover:text-accent">
        Privacy
      </Link>
      <span className="opacity-30">·</span>
      <Link to="/terms" className="hover:text-accent">
        Terms
      </Link>
    </div>
  );
}
